import React, { useState, useRef, useEffect } from "react";
import NavBar from "../components/NavBar/NavBar";
import FirstSection from "../components/About/FirstSection";
import SecondSection from "../components/About/SecondSection";
import FinalSection from "../components/About/FinalSection";
import OurValues from "../components/About/OurValues";
import OurMission from "../components/About/OurMission";


export default function PartnerWithUs() {
  const finalSectionRef = useRef(null);

  return (
    <>
      <NavBar />
      <FirstSection />
      <OurMission />
      <SecondSection />
      <OurValues />
      <FinalSection ref={finalSectionRef} id="finalSection" />
    </>
  );
}
